import { useState } from 'react';
import { message } from 'antd';

export const useClose = (maxClicks = 5) => {
  const [clickCount, setClickCount] = useState(0);

  const [lastClickTime, setLastClickTime] = useState(0);
  const timeLimit = 1000;
  const handleClick = () => {
    const now = Date.now();

    // 判断是否在时间限制内点击
    if (now - lastClickTime <= timeLimit) {
      setClickCount(clickCount + 1);
      console.log(`连续点击次数: ${clickCount}`);
    } else {
      // 超时，重置点击次数
      setClickCount(1);
      console.log(`超时重置，当前点击次数: ${clickCount}`);
    }
    setLastClickTime(now);
    if (clickCount === 2)
      message
        .warning({
          content: `连续点击${maxClicks}次以关闭应用`,
          style: { marginTop: `calc(100vh - 100px)`, color: 'rgba(0,0,0,0.7)', fontWeight: 'bold' }
        })
        .then();
    if (clickCount >= maxClicks) window.close();
  };

  return {
    clickCount,
    maxClicks,
    handleClick
  };
};
